/**
 * @generated SignedSource<<370cb3192d13fc73e66323e5c740f614>>
 * @relayHash b776f132215dfceaf03ff54f5aa51c8a
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b776f132215dfceaf03ff54f5aa51c8a

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type de_BetterDocRecommendationState = "ADMISSION_FAILED" | "ADMITTED" | "ADMITTING" | "MEDIC_CONFIRMED" | "MEDIC_SELECTED" | "NO_SERVICE" | "PENDING" | "RECOMMENDED" | "REJECTED" | "RESEARCHING" | "RESEARCH_FAILED" | "SERVICE_TRIAGE_FAILED" | "TRIAGING";
export type de_BetterDocTestCaseOutcome = "EXISTING_RECOMMENDATION" | "MSN_PENDING" | "NO_NAVIGATION" | "PMN_RECEIVED" | "REQUEST_FAILED" | "UNEXPECTED_RESPONSE";
export type de_BetterDocTestCaseScenario = "MSN" | "MSN_WITH_SECOND_OPINION" | "PMN";
export type De_sendBetterDocTestCaseInput = {
  insuranceCountry: Country;
  scenario: de_BetterDocTestCaseScenario;
};
export type useSendBetterDocTestCaseMutation$variables = {
  input: De_sendBetterDocTestCaseInput;
};
export type useSendBetterDocTestCaseMutation$data = {
  readonly de_sendBetterDocTestCase: {
    readonly testCaseResult: {
      readonly betterDocState: de_BetterDocRecommendationState | null;
      readonly caseId: string | null;
      readonly errorReason: string | null;
      readonly httpStatusCode: number | null;
      readonly insuranceCountry: Country;
      readonly outcome: de_BetterDocTestCaseOutcome;
      readonly partnerSessionId: string;
      readonly recommendationId: string | null;
      readonly sessionId: number;
    } | null;
  };
};
export type useSendBetterDocTestCaseMutation = {
  response: useSendBetterDocTestCaseMutation$data;
  variables: useSendBetterDocTestCaseMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "De_sendBetterDocTestCasePayload",
    "kind": "LinkedField",
    "name": "de_sendBetterDocTestCase",
    "plural": false,
    "selections": [
      {
        "alias": "testCaseResult",
        "args": null,
        "concreteType": "de_BetterDocTestCaseResult",
        "kind": "LinkedField",
        "name": "de_BetterDocTestCaseResult",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerSessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insuranceCountry",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "outcome",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "httpStatusCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "betterDocState",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "caseId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recommendationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorReason",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSendBetterDocTestCaseMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSendBetterDocTestCaseMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "b776f132215dfceaf03ff54f5aa51c8a",
    "metadata": {},
    "name": "useSendBetterDocTestCaseMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "fed3dfc96e43f18ba2fe1ce7c7e50ba1";

export default node;
